// extracted by mini-css-extract-plugin
export default {"support-streamer__container":"support-streamer__container--1F0e3","support-streamer__avatar":"support-streamer__avatar--3_d0T","support-streamer__message":"support-streamer__message--1zi15"};
    if(module.hot) {
      // 1747648180723
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  